module.exports = __webpack_public_path__ + "assets/img/activity-time-22f27f1a.png";